import { GET_SEAT_NUMBERS } from "../components/action-types"


const getSeatNumbersReducer = (state = [], action) => {
    switch (action.type) {
        case (GET_SEAT_NUMBERS):
            return state = action.payload
        default:
            return state
    }
}

export default getSeatNumbersReducer;